import { Role } from "./role";
var User = /** @class */ (function () {
    function User() {
        this._role = Role.Registered;
        this._caps = [];
        this._enabled = true;
    }
    Object.defineProperty(User.prototype, "companyPrimaryContact", {
        get: function () {
            return this._companyPrimaryContact;
        },
        set: function (v) {
            this._companyPrimaryContact = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(User.prototype, "companyName", {
        get: function () {
            return this._companyName;
        },
        set: function (v) {
            this._companyName = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(User.prototype, "enabled", {
        get: function () {
            return this._enabled;
        },
        set: function (value) {
            this._enabled = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(User.prototype, "companyID", {
        get: function () {
            return this._companyID;
        },
        set: function (v) {
            this._companyID = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(User.prototype, "username", {
        get: function () {
            return this._username;
        },
        set: function (v) {
            this._username = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(User.prototype, "password", {
        get: function () {
            return this._password;
        },
        set: function (v) {
            this._password = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(User.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (v) {
            this._id = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(User.prototype, "capabilities", {
        get: function () {
            return this._caps;
        },
        set: function (v) {
            this._caps = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(User.prototype, "role", {
        get: function () {
            return this._role;
        },
        set: function (v) {
            this._role = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(User.prototype, "roleName", {
        get: function () {
            return Role[this._role];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(User.prototype, "firstName", {
        get: function () {
            return this._firstName;
        },
        set: function (v) {
            this._firstName = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(User.prototype, "lastName", {
        get: function () {
            return this._lastName;
        },
        set: function (v) {
            this._lastName = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(User.prototype, "subscription", {
        get: function () {
            return this._subscription;
        },
        set: function (v) {
            this._subscription = v;
        },
        enumerable: true,
        configurable: true
    });
    User.prototype.hasCapability = function (cap) {
        return this._caps && this._caps.some(function (c) { return c == cap; });
    };
    User.prototype.getDisplayName = function () {
        var displayName = [];
        if (this.firstName) {
            displayName.push(this.firstName);
        }
        if (this.lastName) {
            displayName.push(" ");
            displayName.push(this.lastName);
        }
        if (!displayName.length) {
            displayName = [this._username];
        }
        return displayName.join("");
    };
    User.prototype.hasActiveSubscription = function () {
        if (this.subscription) {
            return this.subscription.isActiveSubscription();
        }
        // for people who do not have a subscription object, we return true here.
        return true;
    };
    return User;
}());
export { User };



// WEBPACK FOOTER //
// ./src/app/shared/models/user.ts.pre-build-optimizer.js